import React from 'react';
import PropTypes from 'prop-types';

import { createStructuredSelector } from 'reselect';
import injectReducer from 'utils/injectReducer';
import injectSaga from 'utils/injectSaga';
import { connect } from 'react-redux';
import { compose } from 'redux';
import reducer from './reducer';
import saga from './saga';

import { makeSelectParam, makeSelectLoading } from './selectors';
import { getFilters } from './actions';

import SelectCollapsibleFilter from '../SearchCatalogFilters/selectCollapsible';
import MultiselectFilter from '../SearchCatalogFilters/multiselect';
import MultiselectWithIconFilter from '../SearchCatalogFilters/multiselectWithIcon';

import './styles.scss';

class Search extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    this.props.loadFilters();
  }

  render() {
    const { params, loading } = this.props;

    if (loading || !params.hasOwnProperty('brands')) return null;

    const {
      brands,
      deposits,
      distances,
      fuels,
      brokers,
      products,
      monthly_rates,
      status,
      customerType,
      durations,
      categories,
      gears,
      noviceDriver,
      delivery_times,
    } = params;

    return (
      <div id="CatalogSearch" className="todo-sidebar">
        <SelectCollapsibleFilter
          label="Status offerte"
          options={status}
          name="status"
          className="catalog-filter-status"
          show
        />
        <SelectCollapsibleFilter
          label="Tipologia cliente"
          options={customerType}
          name="customerType"
          show
        />
        <SelectCollapsibleFilter
          label="Rata"
          options={monthly_rates}
          name="monthly_rate"
          show
        />
        <SelectCollapsibleFilter
          label="Anticipo"
          options={deposits}
          name="deposit"
          show
        />
        <SelectCollapsibleFilter
          label="Durata"
          options={durations}
          name="duration"
          show
        />
        <SelectCollapsibleFilter
          label="Km/Anno"
          options={distances}
          name="distance"
        />
        <MultiselectFilter
          label="Tempi di consegna"
          options={delivery_times}
          name="delivery_times"
        />
        <MultiselectFilter
          label="Provider"
          options={brokers}
          name="brokers"
        />
        <MultiselectFilter
          label="Prodotto"
          options={products}
          name="products"
        />
        <MultiselectWithIconFilter
          label="Marca"
          options={brands}
          name="brands"
        />
        <MultiselectFilter
          label="Categoria"
          options={categories}
          name="categories"
        />
        <MultiselectFilter
          label="Alimentazione"
          options={fuels}
          name="fuels"
        />
        <SelectCollapsibleFilter
          label="Cambio"
          options={gears}
          name="gear"
        />
        <SelectCollapsibleFilter
          label="Neopatentato"
          options={noviceDriver}
          name="noviceDriver"
        />
      </div>
    );
  }
}

Search.defaultProps = {};

Search.propTypes = {
  loadFilters: PropTypes.func.isRequired,
};

const mapStateToProps = createStructuredSelector({
  params: makeSelectParam(),
  loading: makeSelectLoading(),
});
export function mapDispatchToProps(dispatch) {
  return {
    loadFilters: () => dispatch(getFilters()),
  };
}

const withReducer = injectReducer({ key: 'catalogSearch', reducer });
const withSaga = injectSaga({ key: 'catalogSearch', saga });

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export default compose(
  withReducer,
  withSaga,
  withConnect,
)(Search);
